import { Text } from "@pallet-hq/hegel"

const JobBoardTitleSection = ({
    hasCollective,
}: {
    hasCollective: boolean
}) => (
    <>
        <Text
            variant="titleLarge"
            mb={["small", "medium", "medium"]}
            textAlign="center"
        >
            Post your open roles, get the <i>right</i> inbound
        </Text>
        <Text
            variant="headlineMedium"
            color="gray600"
            textAlign="center"
            style={{ maxWidth: "700px" }}
        >
            {hasCollective
                ? "Get inbound applications and source from active profiles — all in one subscription."
                : "Apply to be a partner and get your roles featured to an audience specific to your needs."}
        </Text>
    </>
)

export default JobBoardTitleSection
